"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("../store/name/actions");
var bet_validator_1 = require("../validators/bet-validator");
var cookie_helper_1 = require("../helpers/cookie-helper");
var AutoName = (function () {
    function AutoName() {
    }
    AutoName.prototype.setAutoName = function (store) {
        var nameElement = document.getElementById('coinNameInput');
        var language = window['lang'] === null ? 'en' : window['lang'];
        var sessionToken = window['customLoggedIn'] && window['customToken'] ?
            window['customToken'] : cookie_helper_1.default.get('token') != '' ?
            cookie_helper_1.default.get('token') : window['token'];
        if (!store.getState().name.name && !sessionToken) {
            bet_validator_1.default.error(window['langArr'][language].please_login);
            return false;
        }
        else if (!store.getState().name.name && sessionToken) {
            nameElement.value = sessionToken.slice(-4);
            store.dispatch(actions_1.setName({
                name: sessionToken.slice(-4)
            }));
            return true;
        }
        else if (store.getState().name.name && !sessionToken) {
            bet_validator_1.default.error(window['langArr'][language].please_login);
            return false;
        }
        else {
            nameElement.value = store.getState().name.name;
            return true;
        }
    };
    return AutoName;
}());
exports.default = AutoName;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/auto-name/auto-name.ts
// module id = 2007
// module chunks = 4